export function randomId(prefix = 'honeycomb-'): string {
    return `${prefix}${Math.random().toString(36).slice(2, 11)}`;
}
